import { cloneDeep } from 'lodash';
import { PresetViewConfig } from './personalPresets';

// Only automatic persistence uses this snapshot. Explicit Save/Update/Share still
// read the live view. Nothing about the import session is stored across reloads.
let session:
  | {
      owner: symbol;
      pathname: string;
      pageKey: string;
      original: PresetViewConfig;
      onCommit?: () => void;
    }
  | undefined;

export function beginPresetSession(
  owner: symbol,
  pageKey: string,
  original: PresetViewConfig,
  onCommit?: () => void,
) {
  if (session?.owner === owner) return;
  session = {
    owner,
    pageKey: String(pageKey),
    pathname: window.location.pathname,
    original: cloneDeep(original),
    onCommit,
  };
}

export function endPresetSession(owner: symbol) {
  if (session?.owner === owner) session = undefined;
}

export function commitPresetSession(pageKey: string) {
  if (session?.pageKey !== String(pageKey)) return;
  const onCommit = session.onCommit;
  session = undefined;
  // The picker and automatic persistence must start the next import together.
  onCommit?.();
}

function originalView(pageKey?: string) {
  if (!session || session.pathname !== window.location.pathname) return undefined;
  if (pageKey !== undefined && session.pageKey !== String(pageKey)) return undefined;
  return session.original;
}

export function dashboardForAutoPersistence(config: any, pageKey: string) {
  const original = originalView(pageKey);
  if (!original || !config?.state?.metricsChartContainer) return config;
  const result = cloneDeep(config);
  const state = result.state;
  Object.assign(state.metricsChartContainer, cloneDeep(original.metricsChartContainer));
  state['module:trends'] = {
    ...state['module:trends'],
    base: { ...state['module:trends']?.base, ...cloneDeep(original.base) },
  };
  state.metricPanel = { ...state.metricPanel, ...cloneDeep(original.metricPanel) };
  state.dimensionPanel = { ...state.dimensionPanel, ...cloneDeep(original.dimensionPanel) };
  state.toggles = { ...state.toggles, sections: cloneDeep(original.sections) };
  state.summaryWidgets = cloneDeep(original.summaryWidgets);
  state.widgetState = cloneDeep(original.widgetState);
  return result;
}

export function trendsForAutoPersistence(configuration: any) {
  const original = originalView();
  if (!original) return configuration;
  return {
    ...configuration,
    chartMetrics: cloneDeep(original.metricsChartContainer.metrics),
    selectedMetric: original.metricsChartContainer.metric,
    dimensionKeys: cloneDeep(original.base.dimensions),
    dimensionMetrics: cloneDeep(original.base.dimensionMetrics),
    globalOrderBy: original.base.globalOrderBy,
    summaryWidgets: cloneDeep(original.summaryWidgets),
    widgetState: cloneDeep(original.widgetState),
    atomState: {
      ...configuration.atomState,
      metricPanel: { ...configuration.atomState?.metricPanel, ...cloneDeep(original.metricPanel) },
    },
  };
}
